import React from 'react';
import content from '../../assets/imgs/streamingModalC.png';

const CdnStreamingContents = ({ isOpen, onClose, children }) => {
  return (
    <div className={'flex-col'}>
      <div style={{ padding: '0 16px' }}>
        <span
          style={{
            color: '#232323',
            fontFamily: '"Pretendard Variable"',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '140%',
            letterSpacing: '-0.42px',
          }}
        >
          HD 영상과 같은 다량의 영상 컨텐츠를 사용자와 근접한 CDN Server Farm의
          코덱 압축기술을 통하여 사용자에게 고품질의 영상 컨텐츠를 제공해 드리는
          서비스입니다. 인기 영상 컨텐츠의 경우 그 수요를 명확하게 예측하기
          예측하기 힘들기 때문에 Streaming Service를 이용하여 대비하시길
          바랍니다.
        </span>
      </div>
      <img style={{ width: '100%' }} src={content} alt="" />
    </div>
  );
};
CdnStreamingContents.headerTitle = 'STREAMING SERVICE';
export default CdnStreamingContents;
